import {
  BASE_COLORS,
  FONT_FAMILY,
  FONT_WEIGHT,
  FONT_SIZE_PX,
  media,
} from "config/theme/constants";
import styled from "styled-components";

export const SettingsWrapper = styled.div`
  .page-title {
    font-size: ${FONT_SIZE_PX.FONT23};
    font-weight: ${FONT_WEIGHT.normal};
    font-family: ${FONT_FAMILY.main};
    color: ${BASE_COLORS.downRiver};
    opacity: 1;
  }
  .my-account-non-editable .ant-form-item .ant-form-item-label {
    padding: 0 !important;
  }

  .settings-card-permission {
    text-align: center;
    box-shadow: inset 0 0 2px ${BASE_COLORS.altolight};
    margin-top: 10px;
    min-height: 80px;
  }

.form-container {
  padding: 12px 20px 0px;
  width: 60%;
}

@media only screen and ${media.xs}{
  .form-container {
    width: 100%;
  }
}

@media only screen and ${media.md} {
  .form-container {
    width: 80%;
  }
}

@media only screen and ${media.xl}  {
  .form-container {
    width: 70%;
  }
}
`;
